var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 69,
    viewBox: "0 0 60 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7505 34.0541C53.7505 21.3453 53.7505 14.9909 50.2724 11.0427C46.7943 7.0946 41.1963 7.0946 30.0005 7.0946C18.8047 7.0946 13.2067 7.0946 9.72848 11.0427C6.25048 14.9909 6.25048 21.3453 6.25048 34.0541C6.25048 46.7628 6.25048 53.1172 9.72848 57.0655C13.2067 61.0135 18.8047 61.0135 30.0005 61.0135C41.1963 61.0135 46.7943 61.0135 50.2724 57.0655C53.7505 53.1172 53.7505 46.7628 53.7505 34.0541Z",
    stroke: "black",
    strokeWidth: 2.98987
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4068 34.1327H34.8458M34.8458 34.1327C34.8458 35.7517 29.4575 41.1915 29.4575 41.1915M34.8458 34.1327C34.8458 32.4717 29.4575 27.1392 29.4575 27.1392M42.4067 22.6896V45.3924",
    stroke: "black",
    strokeWidth: 2.98987,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2b01a5c41925f21938c3bbef22b4f5d3.svg";
export { ForwardRef as ReactComponent };